import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';

function LocalInstanceBanner() {
  const instanceName = process.env.REACT_APP_LOCAL_INSTANCE_NAME?.trim();
  const frontendBranch = process.env.REACT_APP_LOCAL_FRONTEND_BRANCH?.trim();
  const backendBranch = process.env.REACT_APP_LOCAL_BACKEND_BRANCH?.trim();
  const isVisible =
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_LOCAL_INSTANCE_BANNER === 'true' &&
    Boolean(instanceName);

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      component="aside"
      aria-label="Local development instance"
      sx={{
        alignItems: 'center',
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        columnGap: 2,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        minHeight: 24,
        px: 2,
        rowGap: 0.25,
        position: 'sticky',
        top: 0,
        width: '100%',
        zIndex: theme => theme.zIndex.appBar + 1,
      }}>
      <Typography component="span" variant="caption" fontWeight={700}>
        <FormattedMessage id="INSTANCE" defaultMessage="Instance" />:{' '}
        {instanceName[0].toUpperCase() + instanceName.slice(1)}
      </Typography>
      {frontendBranch && (
        <Typography component="span" variant="caption" fontWeight={700}>
          <FormattedMessage id="FE" defaultMessage="FE" />: {frontendBranch}
        </Typography>
      )}
      {backendBranch && (
        <Typography component="span" variant="caption" fontWeight={700}>
          <FormattedMessage id="BE" defaultMessage="BE" />: {backendBranch}
        </Typography>
      )}
    </Box>
  );
}

export default LocalInstanceBanner;
